<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title">Totally<br/>Washi!</h1>
<h2 class="title1">More than 45 Super Cute Washi Tape Crafts For Kids</h2>
<h2 class="author">Ashley Ann Laz</h2>
<div class="logo"><img alt="Logo" src="images/29500.gif"/><br/>Avon, Massachusetts</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?5679b722